/* tslint:disable */
/* eslint-disable */
/**
 * MAPIIO API
 * API mapové aplikace Mapiio pro klientskou JavaScriptovou / React část.
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



    /**
 * 
 * @export
 * @enum {string}
 */

export const EnumLayerConditionTypeE = {
    LAYER_STRING_CONDITION_EVO: 'LayerStringConditionEVO',
    LAYER_INTEGER_CONDITION_EVO: 'LayerIntegerConditionEVO',
    LAYER_BOOLEAN_CONDITION_EVO: 'LayerBooleanConditionEVO'
} as const;

export type EnumLayerConditionTypeE = typeof EnumLayerConditionTypeE[keyof typeof EnumLayerConditionTypeE];



